import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from './components/welcome/welcome.vue'
import Dashboard from './components/dashboard/dashboard.vue'
import Profile from './components/dashboard/profile.vue'
import Pwdchange from './components/dashboard/pwdchange.vue'
import Leaderboard from './components/dashboard/leaderboard.vue'
import Register from './components/auth/register.vue'
import Login from './components/auth/login.vue'
import Categories from './components/lists/categories.vue'
import Areas from './components/lists/areas.vue'
import Courses from './components/lists/courses.vue'
import CoursePreview from './components/lists/items/course/course_preview.vue'
import CourseContent from './components/lists/items/course/course_content.vue'
import ChapterContent from './components/lists/items/course/chapter_content.vue'
import CourseAdminContent from './components/lists/items/course/course_admin_content.vue'

import Test from './components/lists/items/course/test.vue'

import LessonUserContent from './components/lists/items/lesson/lesson_user_content.vue'
import LessonAdminContent from './components/lists/items/lesson/lesson_admin_content.vue'
import AdminContent from './components/lists/items/tasks/admin_content.vue'
import AdminType24 from './components/lists/items/tasks/admin_type24.vue'
import AdminType56 from './components/lists/items/tasks/admin_type56.vue'
import AdminType7 from './components/lists/items/tasks/admin_type7.vue'
import AdminType8 from './components/lists/items/tasks/admin_type8.vue'
import AdminType_11 from './components/lists/items/tasks/admin_type_11.vue'
import AdminCategory from './components/lists/items/groups/admin_category.vue'
import AdminArea from './components/lists/items/groups/admin_area.vue'
import AdminCourse from './components/lists/items/groups/admin_course.vue'
import AdminChapter from './components/lists/items/groups/admin_chapter.vue'
import AdminLesson from './components/lists/items/groups/admin_lesson.vue'
import ShowContent from './components/lists/items/tasks/show_content.vue'
// import store from './store'

Vue.use(VueRouter)

let router = new VueRouter({
 // mode: 'history', 
  routes : [
    { path: '/404', 
      component: Login 
    },  
    { path: '/', 
      name: 'welcome',
      component: Welcome,
      meta: {
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      }
    }, { 
      path: '/register', 
      name: 'register',
      component: Register,
      meta: {
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      },
    }, { 
      path: '/login', 
      name: 'login',
      component: Login,
      meta: {
        requiresAuth : false,
        forUser : false,
        forAdmin: false
      }
    }, { 
      path: '/dashboard', 
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true,
        breadcrumbs: [{
          text: 'Dashboard', disabled: false, href: '/#/dashboard'
        }]
      }
    }, { 
      path: '/profile', 
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/pwdchange', 
      name: 'pwdchange',
      component: Pwdchange,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/leaderboard', 
      name: 'leaderboard',
      component: Leaderboard,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/categories', 
      name: 'categories',
      component: Categories,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/areas/:id', 
      name: 'areas',
      component: Areas,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/courses/:id', 
      name: 'courses',
      component: Courses,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }, { 
      path: '/course_admin_content/:id', 
      name: 'course_admin_content',
      component: CourseAdminContent,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/course_preview/:id', 
      name: 'course_preview',
      component: CoursePreview,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    },{ 
      path: '/course_content/:id', 
      name: 'course_content',
      component: CourseContent,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    },{ 
      path: '/chapter_content/:id', 
      name: 'chapter_content',
      component: ChapterContent,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    }, { 
      path: '/lesson_admin_content/:id', 
      name: 'lesson_admin_content',
      component: LessonAdminContent,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/lesson_user_content/:id', 
      name: 'lesson_user_content',
      component: LessonUserContent,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: false
      }
    }, { 
      path: '/admin_content/:id', 
      name: 'admin_content',
      component: AdminContent,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/show_content/:id', 
      name: 'show_content',
      component: ShowContent,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type24/:id', 
      name: 'admin_type24',
      component: AdminType24,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type56/:id', 
      name: 'admin_type56',
      component: AdminType56,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type7/:id', 
      name: 'admin_type7',
      component: AdminType7,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_type8/:id', 
      name: 'admin_type8',
      component: AdminType8,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    },{ 
      path: '/admin_type_11/:id', 
      name: 'admin_type_11',
      component: AdminType_11,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_category/:id', 
      name: 'admin_category',
      component: AdminCategory,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_area/:id', 
      name: 'admin_area',
      component: AdminArea,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_chapter/:id', 
      name: 'admin_chapter',
      component: AdminChapter,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_course/:id', 
      name: 'admin_course',
      component: AdminCourse,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/admin_lesson/:id', 
      name: 'admin_lesson',
      component: AdminLesson,
      meta: {
        requiresAuth : true,
        forUser : false,
        forAdmin: true
      }
    }, { 
      path: '/test/', 
      name: 'Test',
      component: Test,
      meta: {
        requiresAuth : true,
        forUser : true,
        forAdmin: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record  => record.meta.requiresAuth)
  const forAdmin = to.matched.some(record  => record.meta.forAdmin)
  const forUser = to.matched.some(record  => record.meta.forUser)
  const isLogged = localStorage.getItem('token') != null
  const isAdmin = localStorage.getItem('role_id') == 2

 ////
  if(!requiresAuth) { 
    if (!isLogged) {
      next()
      return
    } else {
      next( { name: 'dashboard'} )
      return  
    }
  }

  if (isAdmin && forAdmin) {
    next()
    return
  }

  if (isAdmin && !forAdmin) {
    next( { name: 'dashboard'} )
    return
  }

  // is user
  if (!forUser) {
    next( { name: 'dashboard'} )
    return
  }

  next()
 
})

router.afterEach((to, from) => {
  if (from.name == ' ') {
      from.name=''
  }
  var bread = [];
  let position = JSON.parse(localStorage.getItem('position'))

//  console.log(to.name)
//  console.log(position)

  bread.push({  text: 'Dashboard', disabled: false, href: '/#/dashboard' })
  if (to.name == 'dashboard') { 
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return 
  }
  // ***************************************
  if (to.name == 'categories') {
    bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }
  // ***************************************
  if (to.name == 'profile') {
    bread.push({  text: 'Profile', disabled: false, href: '/#/profile' })
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }
  // ***************************************
  if (to.name == 'pwdchange') {
    bread.push({  text: 'Pwdchange', disabled: false, href: '/#/pwdchange' })
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }
  // ***************************************
  if (to.name == 'leaderboard') {
    bread.push({  text: 'Leaderboard', disabled: false, href: '/#/leaderboard' })
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }
  // ***************************************
  if (to.name == 'areas') {
    bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
    bread.push({  text: position.activeCategory.name, disabled: false, href: '/#/areas/' + position.activeCategory.id})
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }
  // ***************************************
    if (to.name == 'courses') {
      bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
      bread.push({  text: position.activeCategory.name, disabled: false, href: '/#/areas/' + position.activeCategory.id})
      bread.push({  text: position.activeArea.name, disabled: false, href: '/#/courses/' + position.activeArea.id})
      localStorage.setItem('bc',JSON.stringify(bread)) 
      return
    }
  // ***************************************
    if ((to.name == 'course_admin_content') || (to.name == 'course_preview') || (to.name == 'course_content')) {
      bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
      bread.push({  text: position.activeCategory.name, disabled: false, href: '/#/areas/' + position.activeCategory.id})
      bread.push({  text: position.activeArea.name, disabled: false, href: '/#/courses/' + position.activeArea.id})
      bread.push({  text: position.activeCourse.name, disabled: false, href: '/#/'+to.name+'/' + position.activeCourse.id})
      localStorage.setItem('bc',JSON.stringify(bread)) 
      return
    }
  // ***************************************
  if (to.name == 'lesson_admin_content') {
    bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
    bread.push({  text: position.activeCategory.name, disabled: false, href: '/#/areas/' + position.activeCategory.id})
    bread.push({  text: position.activeArea.name, disabled: false, href: '/#/courses/' + position.activeArea.id})
    bread.push({  text: position.activeCourse.name, disabled: false, href: '/#/course_admin_content/' + position.activeCourse.id})
    // bread.push({  text: position.activeLesson.name, disabled: false, href: '/#/lesson_admin_content/' + position.activeLesson.id})
    //bread.push({  text: position.activeLesson.name, disabled: false, href: '/#/chapter_content/' + position.activeChapter.id})
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }

  if (to.name.substring(0,10) == 'admin_type' || to.name == 'admin_content') {
    bread.push({  text: 'Categories', disabled: false, href: '/#/categories' })
    bread.push({  text: position.activeCategory.name, disabled: false, href: '/#/areas/' + position.activeCategory.id})
    bread.push({  text: position.activeArea.name, disabled: false, href: '/#/courses/' + position.activeArea.id})
    bread.push({  text: position.activeCourse.name, disabled: false, href: '/#/course_admin_content/' + position.activeCourse.id})
    bread.push({  text: position.activeLesson.name, disabled: false, href: '/#/lesson_admin_content/' + position.activeLesson.id})
    localStorage.setItem('bc',JSON.stringify(bread)) 
    return
  }


/*  if (to.name == 'chapter_content'  || 
  (to.name == 'areas') || (to.name == 'courses')
      || (to.name == 'course_admin_content') || (to.name == 'lesson_admin_content') || (to.name == 'course_content') || (to.name == 'admin_content')
  { 
  */
  
})


    /*

  adminLinks: { category: 'categories',
  area: 'areas',
  course: 'courses',
  chapter: 'course_admin_content',
  lesson: 'lesson_admin_content' 
  },
  userLinks: { category: 'categories',
  area: 'areas',
  course: 'courses',
  chapter: 'course_content',
  lesson: 'chapter_content' 
  },*/

 


export default router
